import React from "react"
import { useSegment } from "tracking"
import { useProductCard } from "../../hooks/useProductCard"
import { ColorSwatch } from "../../../ui-shared/components/ColorSwatch"
import { productCardSwatches } from "./ProductCard.css"

export const ProductCardColorSwatch: React.FC = () => {
  const { track } = useSegment()
  const { productCardData, setIsShadeSelectorOpen } = useProductCard()
  if (!productCardData.swatchImages?.length) return null

  const {
    brandName = "",
    productName = "",
    variationName = "",
  } = productCardData

  return (
    <button
      type="button"
      onClick={(event) => {
        event.preventDefault()
        if (setIsShadeSelectorOpen) {
          setIsShadeSelectorOpen?.(true)
          track({
            event: "Page Element Clicked",
            properties: {
              module_content: "Open Shade Selector",
              module_content_details: `PLP Colour Swatch: ${brandName} ${productName} ${variationName}`,
            },
          })
        }
      }}
    >
      <div className={productCardSwatches}>
        <ColorSwatch
          visibleItemCount={4}
          items={productCardData.swatchImages}
        />
      </div>
    </button>
  )
}
